import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './experiments/web_autotest_female_funnel_check'
import web_fallback_on_payment_male_us from './experiments/web_fallback_on_payment_male_us'
import web_fallback_on_payment_male_eu from './experiments/web_fallback_on_payment_male_eu'
import web_fallback_on_payment_male_row from './experiments/web_fallback_on_payment_male_row'
import web_en_countries_price_optimization from './experiments/web_en_countries_price_optimization'
import web_walking_models_from_creos from './experiments/web_walking_models_from_creos'
import web_walking_gs_indoor_intent from './experiments/web_walking_gs_indoor_intent'
import web_walking_gs_welcome_topic from './experiments/web_walking_gs_welcome_topic'
import web_tai_chi_walking_walk_at_loader from './experiments/web_tai_chi_walking_walk_at_loader'
import web_yoga_female_scratch_card_before_the_paywall from './experiments/web_yoga_female_scratch_card_before_the_paywall'
import web_fasting_f_personalized_coupon from './experiments/web_fasting_f_personalized_coupon'
import web_tai_chi_al_risk_free_offer from './experiments/web_tai_chi_al_risk_free_offer'
import web_tai_chi_al_paywall_plan_benefits from './experiments/web_tai_chi_al_paywall_plan_benefits'
import web_paywall_with_social_proof from './experiments/web_paywall_with_social_proof'
import web_fallback_loose_chance from './experiments/web_fallback_loose_chance'
import web_welcome_for_applovin_tai_chi_walking from './experiments/web_welcome_for_applovin_tai_chi_walking'
import web_tai_chi_female_v2_moto_block from './experiments/web_tai_chi_female_v2_moto_block'
import web_tai_chi_fem_v2_gifs_exercise from './experiments/web_tai_chi_fem_v2_gifs_exercise'
import web_female_tai_chi_walking_v2_fr from './experiments/web_female_tai_chi_walking_v2_fr'
import web_feedback_with_social_proof from './experiments/web_feedback_with_social_proof'
import web_upsell_price_based_card_type from './experiments/web_upsell_price_based_card_type'
import web_upsells_on_tai_chi from './experiments/web_upsells_on_tai_chi'
import web_water_fasting_models_from_creos from './experiments/web_water_fasting_models_from_creos'
import web_water_fasting_pr_guide from './experiments/web_water_fasting_pr_guide'
import web_fasting_f_welcome_topic from './experiments/web_fasting_f_welcome_topic'
import web_water_fasting_ui_and_copy_optimization from './experiments/web_water_fasting_ui_and_copy_optimization'
import web_fasting_f_paywall_before_after from './experiments/web_fasting_f_paywall_before_after'
import web_female_tai_chi_walking_v2_de from './experiments/web_female_tai_chi_walking_v2_de'
import web_fasting_fem_sales_tax_exclusion_i3 from './experiments/web_fasting_fem_sales_tax_exclusion_i3'
import web_tai_chi_male_checkout_update from './experiments/web_tai_chi_male_checkout_update'
import web_revisit_last_section_female from './experiments/web_revisit_last_section_female'
import web_less_sleep_more_calories from './experiments/web_less_sleep_more_calories'
import web_refactor_result_complete from './experiments/web_refactor_result_complete'
import web_tai_chi_walking_fem_v2_input_screens_before_paywall from './experiments/web_tai_chi_walking_fem_v2_input_screens_before_paywall'
import web_reprice_upsells_nonus from './experiments/web_reprice_upsells_nonus'
import web_unify_upsell_second_screen from './experiments/web_unify_upsell_second_screen'
import web_legacy_plan_picker_tai_chi_yoga_walking from './experiments/web_legacy_plan_picker_tai_chi_yoga_walking'
import web_chair_workouts_large_checkout from './experiments/web_chair_workouts_large_checkout'
import web_ml_price_prediction from './experiments/web_ml_price_prediction'
import web_remove_1_week_from_plans from './experiments/web_remove_1_week_from_plans'
import web_show_2_plans from './experiments/web_show_2_plans'
import web_tai_chi_yoga_male_scratch_card from './experiments/web_tai_chi_yoga_male_scratch_card'
import web_tai_chi_yoga_m_glucose from './experiments/web_tai_chi_yoga_m_glucose'
import web_fasting_fem_ai_coach_meal_plan from './experiments/web_fasting_fem_ai_coach_meal_plan'
import web_pix_payment_method_for_br from './experiments/web_pix_payment_method_for_br'
import web_pricing_au_dk_se_ch from './experiments/web_pricing_au_dk_se_ch'
import web_fasting_f_improve_copy from './experiments/web_fasting_f_improve_copy'
import web_f_tai_chi_walking_v2_al_bmi_post_funnel from './experiments/web_f_tai_chi_walking_v2_al_bmi_post_funnel'
import web_tai_chi_walking_fem_v2_ai_coach from './experiments/web_tai_chi_walking_fem_v2_ai_coach'
import web_tai_chi_walking_v2_lee_as_a_model from './experiments/web_tai_chi_walking_v2_lee_as_a_model'
import web_tai_chi_pr_offer_update from './experiments/web_tai_chi_pr_offer_update'
import web_redirect_simple_moves from './experiments/web_redirect_simple_moves'
import web_tai_chi_walking_fem_v2_sports_kit from './experiments/web_tai_chi_walking_fem_v2_sports_kit'
import web_ml_price_prediction_high_wtp_i2_1 from './experiments/web_ml_price_prediction_high_wtp_i2_1'
import web_chair_yoga_gs_adapted_for_senior_audiences from './experiments/web_chair_yoga_gs_adapted_for_senior_audiences'
import web_m_chair_fitness_age from './experiments/web_m_chair_fitness_age'
import web_ml_price_prediction_high_wtp_i2_2 from './experiments/web_ml_price_prediction_high_wtp_i2_2'
import web_activity_f_fasting_paywall from './experiments/web_activity_f_fasting_paywall'
import web_ui_multichange_planpicker from './experiments/web_ui_multichange_planpicker'
import web_planpicker_save_w_checkout_update from './experiments/web_planpicker_save_w_checkout_update'
import web_male_paywall_redesign from './experiments/web_male_paywall_redesign'
import web_large_paywall_update from './experiments/web_large_paywall_update'
import web_auto_checkout from './experiments/web_auto_checkout'
import web_add_more_plans_to_program from './experiments/web_add_more_plans_to_program'
import web_upsell_supplements_peptides from './experiments/web_upsell_supplements_peptides'
import web_price_before_scratch_new_funnels from './experiments/web_price_before_scratch_new_funnels'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	// fasting
	female: {
		web_fallback_loose_chance,
		web_autotest_female_funnel_check,
		web_fasting_f_personalized_coupon,
		web_feedback_with_social_proof,
		web_fasting_fem_sales_tax_exclusion_i3,
		web_revisit_last_section_female,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_fasting_f_welcome_topic,
		web_fasting_fem_ai_coach_meal_plan,
		web_fasting_f_paywall_before_after,
		web_fasting_f_improve_copy,
		web_unify_upsell_second_screen,
		web_ui_multichange_planpicker,
		web_ml_price_prediction_high_wtp_i2_1,
		web_ml_price_prediction_high_wtp_i2_2,
		web_add_more_plans_to_program,
		web_price_before_scratch_new_funnels,
	},
	male: {
		web_en_countries_price_optimization,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_unify_upsell_second_screen,
		web_male_paywall_redesign,
	},
	main: {},

	// yoga
	'activity-female-yoga': {
		web_yoga_female_scratch_card_before_the_paywall,
		web_legacy_plan_picker_tai_chi_yoga_walking,
	},
	'activity-male-chair-workouts': {
		web_paywall_with_social_proof,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_chair_workouts_large_checkout,
		web_m_chair_fitness_age,
		web_male_paywall_redesign,
	},
	'main-yoga': {
		web_chair_yoga_gs_adapted_for_senior_audiences,
	},

	// walking
	'activity-female-walking': {
		web_fallback_loose_chance,
		web_ui_multichange_planpicker,
		web_planpicker_save_w_checkout_update,
		web_en_countries_price_optimization,
		web_upsell_price_based_card_type,
		web_upsells_on_tai_chi,
		web_legacy_plan_picker_tai_chi_yoga_walking,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_unify_upsell_second_screen,
		web_activity_f_fasting_paywall,
		web_large_paywall_update,
		web_ml_price_prediction,
		web_add_more_plans_to_program,
	},
	'activity-male-walking': {
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_upsell_price_based_card_type,
		web_upsells_on_tai_chi,
		web_unify_upsell_second_screen,
	},
	'activity-female-nordic-walking-fwf': {},
	'female-printable-walking': {},
	'main-walking': {
		web_walking_models_from_creos,
		web_walking_gs_indoor_intent,
		web_walking_gs_welcome_topic,
	},

	// pilates
	'activity-female-pilates': {
		web_auto_checkout,
	},
	'activity-female-boudoir-pilates-fwf': {},

	// activity
	'activity-female-v2': {},
	'activity-male': {},
	'main-activity': {},

	// tai-chi
	'activity-female-tai-chi': {},
	'activity-female-tai-chi-move': {},
	'activity-female-tai-chi-walking': {},
	'activity-female-tai-chi-walking-v2': {
		web_fallback_loose_chance,
		web_ui_multichange_planpicker,
		web_planpicker_save_w_checkout_update,
		web_tai_chi_female_v2_moto_block,
		web_tai_chi_fem_v2_gifs_exercise,
		web_female_tai_chi_walking_v2_fr,
		web_upsell_price_based_card_type,
		web_female_tai_chi_walking_v2_de,
		web_upsells_on_tai_chi,
		web_less_sleep_more_calories,
		web_tai_chi_walking_fem_v2_input_screens_before_paywall,
		web_tai_chi_walking_fem_v2_ai_coach,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_legacy_plan_picker_tai_chi_yoga_walking,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_unify_upsell_second_screen,
		web_pix_payment_method_for_br,
		web_ml_price_prediction,
		web_tai_chi_walking_v2_lee_as_a_model,
		web_redirect_simple_moves,
		web_tai_chi_walking_fem_v2_sports_kit,
		web_activity_f_fasting_paywall,
		web_large_paywall_update,
		web_upsell_supplements_peptides,
	},
	'activity-female-tai-chi-walking-pr': {
		web_upsells_on_tai_chi,
		web_refactor_result_complete,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_unify_upsell_second_screen,
		web_pix_payment_method_for_br,
		web_tai_chi_pr_offer_update,
		web_ml_price_prediction,
		web_activity_f_fasting_paywall,
		web_upsell_supplements_peptides,
	},
	'activity-male-tai-chi-walking': {},
	'activity-male-tai-chi-yoga': {
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_male_scratch_card,
		web_upsells_on_tai_chi,
		web_male_paywall_redesign,
	},
	'activity-male-tai-chi-yoga-pr': {
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_male_scratch_card,
		web_pix_payment_method_for_br,
		web_upsells_on_tai_chi,
		web_tai_chi_pr_offer_update,
		web_unify_upsell_second_screen,
		web_tai_chi_yoga_m_glucose,
		web_price_before_scratch_new_funnels,
		web_redirect_simple_moves,
	},
	'activity-female-chair-tai-chi-fwf': {},
	'activity-male-chair-tai-chi': {
		web_male_paywall_redesign,
		web_auto_checkout,
		web_price_before_scratch_new_funnels,
		web_redirect_simple_moves,
	},
	'tai-chi-male-golfers-fwf': {},
	'main-tai-chi': {},
	'main-tai-chi-pr': {},
	'main-tai-chi-walking': {
		web_tai_chi_walking_walk_at_loader,
	},
	'main-tai-chi-walking-pr': {},

	// glp
	'female-glp': {},
	'glp-1': {},

	// calisthenics

	// japanese-walking
	'activity-female-walking-japanese': {},
	'activity-female-walking-japanese-v2': {},

	// asian-pilates

	// military

	// water-fasting
	'female-water-fasting': {
		web_fallback_loose_chance,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_water_fasting_models_from_creos,
		web_water_fasting_pr_guide,
		web_water_fasting_ui_and_copy_optimization,
		web_unify_upsell_second_screen,
		web_ui_multichange_planpicker,
		web_price_before_scratch_new_funnels,
	},
	'female-hashimoto-diet': {
		web_price_before_scratch_new_funnels,
	},
	'male-water-fasting': {},

	// ayurveda fwf
	'female-ayurveda-fwf': {},

	// high-protein

	// diets
	'female-cortisol-diet': {},
	'female-menopause-diet': {},
	'female-mediterranean-diet': {},
	'female-anti-inflammatory-diet': {},
	'female-ramadan-fwf': {},
	'female-korean-glow-diet': {},

	// applovin
	'activity-male-chair-workouts-al': {},
	'activity-male-chair-tai-chi-al': {
		web_ml_price_prediction,
		web_price_before_scratch_new_funnels,
		web_redirect_simple_moves,
	},
	'activity-female-yoga-al': {},
	'activity-female-walking-al': {},
	'activity-male-tai-chi-yoga-al': {},
	'activity-male-tai-chi-walking-al': {},
	'female-al': {},
	'female-water-fasting-al': {},
	'activity-female-tai-chi-walking-al': {},
	'activity-female-tai-chi-walking-v2-al': {
		web_ui_multichange_planpicker,
		web_planpicker_save_w_checkout_update,
		web_tai_chi_al_risk_free_offer,
		web_tai_chi_al_paywall_plan_benefits,
		web_welcome_for_applovin_tai_chi_walking,
		web_upsells_on_tai_chi,
		web_refactor_result_complete,
		web_reprice_upsells_nonus,
		web_pricing_au_dk_se_ch,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_unify_upsell_second_screen,
		web_pix_payment_method_for_br,
		web_f_tai_chi_walking_v2_al_bmi_post_funnel,
		web_ml_price_prediction_high_wtp_i2_1,
		web_ml_price_prediction_high_wtp_i2_2,
		web_large_paywall_update,
		web_upsell_supplements_peptides,
		web_redirect_simple_moves,
	},

	// other
}

export default experimentsConfig
